"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/es/SvgIcon/SvgIcon"));
var NightshroudIcon = /** @class */ (function (_super) {
    __extends(NightshroudIcon, _super);
    function NightshroudIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NightshroudIcon.prototype.render = function () {
        return (react_1.default.createElement(SvgIcon_1.default, null,
            react_1.default.createElement("svg", null,
                react_1.default.createElement("path", { d: "m 8.8064347,18.997016 C 7.3028519,18.756118 5.5549589,18.071778 4.6238439,17.359433 c -0.263983,-0.201959 -0.356549,-0.322078 -0.205701,-0.266934 1.237194,0.452279 1.749572,0.539106 3.154085,0.534479 1.1981858,-0.004 1.6918268,-0.06831 2.3998468,-0.312917 2.5983653,-0.89767 4.4849713,-2.781315 5.2987993,-5.290481 0.73717,-2.2728138 0.386448,-4.8535305 -0.936811,-6.8933635 -1.02321,-1.577297 -2.376907,-2.606463 -4.308485,-3.275576 -0.9301693,-0.322217 -1.2936963,-0.374052 -2.5904851,-0.369374 -1.398111,0.005 -1.875513,0.0893 -3.01695,0.532478 -0.588637,0.228545 0.484437,-0.502 1.407329,-0.958106 1.401723,-0.69274903 2.4834028,-0.93960403 4.1466028,-0.94631503 2.6834923,-0.01083 4.7903153,0.860471 6.7370113,2.78616403 1.009736,0.998841 1.274028,1.361197 1.803803,2.473089 0.805373,1.690315 0.990283,2.496682 0.97485,4.2511567 -0.01533,1.7422898 -0.27885,2.8190108 -1.056281,4.3158278 -1.202767,2.315727 -3.49875,4.157791 -5.985532,4.802181 -0.900673,0.233387 -2.9005703,0.37366 -3.6394913,0.255274 z M 4.6238439,15.332981 c -2.944334,-0.642278 -5.05916696,-3.754299 -4.54430296,-6.6870335 0.56223,-3.20253 3.61174996,-5.433137 6.73921096,-4.929475 4.4888751,0.722912 6.5755071,5.9436927 3.7897391,9.4819715 -1.4317743,1.818532 -3.7093481,2.630872 -5.9846471,2.134537 z" }))));
    };
    return NightshroudIcon;
}(react_1.Component));
exports.default = NightshroudIcon;



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/NightshroudIcon.tsx
// module id = 791
// module chunks = 0